import React from 'react';
import { Tooltip } from '@mui/material';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

export const SAVED_TEXT = 'Saved to the client\'s records when you click Proceed. Clear it to leave it out.';
export const NOT_SAVED_TEXT = 'Shown for reference only. Not saved to the client\'s records.';

/** Marks an extracted field as saved on Proceed, or only shown. `note` adds detail to the tooltip. */
function SaveStatusIcon({ saved, note }) {
    const Icon = saved ? SaveOutlinedIcon : VisibilityOutlinedIcon;
    const text = saved ? SAVED_TEXT : NOT_SAVED_TEXT;
    return (
        <Tooltip title={note ? `${text} ${note}` : text} arrow placement="top">
            <Icon
                aria-label={saved ? 'Saved' : 'Not saved'}
                sx={{ fontSize: 15, color: saved ? 'success.main' : 'text.disabled', verticalAlign: 'middle', flexShrink: 0 }}
            />
        </Tooltip>
    );
}

export default SaveStatusIcon;
